import { CommonModule } from '@angular/common'
import { ModuleWithProviders, NgModule } from '@angular/core'
import { IconComponent } from '@ftr/foundation'
import { SelectSearchComponent } from '~app/shared/select-search/select-search.component'
import { LocationNameComponent } from './location-name/location-name.component'
import { LocationSelectListComponent } from './location-select/location-select-list.component'
import { LocationSelectComponent } from './location-select/location-select.component'

/**
 * Shared module for displaying (but not modifying) available courthouse and courtroom information
 */
@NgModule({
  imports: [CommonModule, IconComponent, SelectSearchComponent],
  declarations: [LocationSelectComponent, LocationSelectListComponent, LocationNameComponent],
  exports: [LocationSelectComponent, LocationNameComponent, LocationSelectListComponent],
})
export class LocationModule {
  static forRoot(): ModuleWithProviders<LocationModule> {
    return {
      ngModule: LocationModule,
    }
  }
}
